export const extractInfo = (data, term) => {
  const info = data.find(o => o.id === term);
  return info;
};
